import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import axios from 'axios';

// Fetch the global "default" company rows for a specific set of company_bids
// (stored under the reserved DEFAULTS partition). Targeted by bid so cost is
// bounded by the caller's list, never the whole DEFAULTS partition.
export const getDefaultCompanies = async (companyBids) => {
  const apiPath = `company/defaults-get`;

  const body = {
    company_bids: companyBids,
  };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    body: JSON.stringify(body),
    data: body,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const signedRequest = await createSignedRequest(request);

  let response = await axios(signedRequest);
  response = response.data;

  return {
    Items: response.Items || [],
  };
};
